<template>
  <div>
    <div class="mb-12 to-hide">
      <div class="d-flex justify-space-between align-center mb-3">
        <Button theme="8" @click.native="print()" v-if="$route.query.preview">
          Export PDF
        </Button>
      </div>
      <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
        <div class="d-flex" style="gap: 24px">
          <div>
            <v-img
              :src="require('../../assets/mhesr.png')"
              min-width="100"
              max-width="100"
              aspect-ratio="1"
            ></v-img>
          </div>

          <div>
            <div class="page-title">
              สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม
              (สป.อว.)
            </div>
             <Button
                v-if=" currentStep == 2 || currentStep == 3 || currentStep == 4"
                theme="4"
                min-width="120px"
                :disabled="isLoading"
                @onClick="autoField(currentStep, plan_code)"
              >
                autoField - step {{ currentStep }} - {{ plan_code }}
              </Button>
            <div class="d-flex" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="jam:clock"
                color="var(--theme-color-nine)"
              ></Iconify>
              <div>
                วันที่เปิดรับโครงการ {{ toDateRangeFormat(masterData.form_a?.main_project?.start_date, masterData.form_b?.main_project?.end_date) }}
              </div>
            </div>

            <div class="d-flex" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="jam:clock"
                color="var(--theme-color-nine)"
              ></Iconify>
              <div>
                <div>
                  วันที่พิจารณาโครงการ {{ toDateFormat(masterData.form_a?.main_project?.consider_date) }}
                </div>
                <div>
                  {{ masterData.form_a?.main_project?.name }}
                </div>
              </div>
            </div>

        
            
            <div
                v-if="docTypeName()"
                class="d-flex align-center"
                style="gap: 18px"
            >
              <Iconify
                  class="left-side d-flex justify-end"
                  size="15px"
                  icon="ion:mail-unread"
              ></Iconify>
              <span>{{ docTypeName() }}</span>
            </div>
          </div>
        </div>

        <div class="budget-tag">
          <div>ปี งปม.</div>
          <div>
            {{
              masterData.form_b?.fiscal_year || masterData.main_project?.fiscal_year
            }}
          </div>
        </div>
      </divcard>

      <StatusStep
        v-if="!$route.query.preview"
        :current-step="currentStep"
        :steps="documentSteps"
        @onClick="jumpStep"
      ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <DFormGeneral
        v-if="currentStep === 1 && !$route.query.preview"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f1_formKey"
      ></DFormGeneral>
      <DFormProject
        v-if="currentStep === 2"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></DFormProject>
      <DFormPlan
        v-if="currentStep === 3"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f3_formKey"
      ></DFormPlan>
      <DFormOOI
      v-if="currentStep === 4"
        :masterData="{ ...masterData, updateId }"
        :is-same-id="isSameId()"
        :key="f4_formKey"
      ></DFormOOI>
      <DFormAttachment
        v-if="currentStep === 5"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f5_formKey"
      ></DFormAttachment>
      <DFormSummary
        v-if="currentStep === 6"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f6_formKey"
      ></DFormSummary>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between to-hide">
      <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

      <div class="flex-center" v-if="!$route.query.preview">
        <Button
            v-if="currentStep !== 1"
            theme="3"
            min-width="120px"
            :disabled="isLoading"
            @onClick="backForm"
          >
            &lt; ย้อนกลับ
          </Button>

        <Button
          theme="4"
          min-width="120px"
          :disabled="isLoading"
          @onClick="saveDraft"
          >บันทึกฉบับร่าง</Button
        >
        <Button
          theme="3"
          min-width="120px"
          :disabled="isLoading || doNotSubmit"
          @onClick="nextForm"
        >
          {{ currentStep === 6 ? "ยื่นโครงการ" : "ถัดไป >" }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep";
import Button from "../../components/input/Button";
import {
  eventBus,
  toDateFormat,
  toDateRangeFormat, validateEmail,
} from "../../plugins/global-funcs";
import DFormGeneral from "./D/DFormGeneral";
import DFormProject from "./D/DFormProject";
import DFormPlan from "./D/DFormPlan";
import DFormOOI from "./D/DFormOOI";
import DFormAttachment from "./D/DFormAttachment";
import DFormSummary from "./D/DFormSummary";
import { mapState } from "vuex";

export default {
  name: "FormA",
  components: {
    StatusStep,
    Button,
    DFormGeneral,
    DFormProject,
    DFormPlan,
    DFormOOI,
    DFormAttachment,
    DFormSummary,
  },
  data() {
    return {
      toDateFormat,
      toDateRangeFormat,
      currentStep: 1,
      doNotSubmit: false,
      documentSteps: [
        {
          no: 1,
          name: "ข้อมูลทั่วไป",
        },
        {
          no: 2,
          name: "ข้อมูลโครงการ",
        },
        {
          no: 3,
          name: "แผนการดำเนินงาน",
        },
        {
          no: 4,
          name: "ผลผลิต",
        },
        {
          no: 5,
          name: "เอกสารแนบ",
        },
      ],
      formGeneral: {},
      formProject: {},
      formPlan: {},
      formOOI: {},
      formAttachment: {},
      masterData: {},
      f1_formKey: 0,
      f2_formKey: 100,
      f3_formKey: 200,
      f4_formKey: 300,
      f5_formKey: 400,
      f6_formKey: 500,
      updateId: undefined,
      plan_code: "",
    };
  },
  async created() {
    if (
      !this.$route.query.main_project_id &&
      !this.$route.query.id &&
      !this.$route.query.inception_id
    )
      return this.onCancel();
    // this.stepSetter()
    await this.getMasterData();
    if (this.$route.query.preview) return this.summaryForm();
    this.retrieveForms();

    //For Dev
    // this.currentStep = 4
  },
  beforeDestroy() {
    eventBus.$off('aFormGeneralSend')
    eventBus.$off('aFormGeneral')
    eventBus.$off('aFormProjectSend')
    eventBus.$off('aFormProject')
    eventBus.$off('aFormPlanSend')
    eventBus.$off('aFormPlan')
    eventBus.$off('aFormPlanSetData')
    eventBus.$off('aFormOOISend')
    eventBus.$off('aFormOOI')
    eventBus.$off('aFormOOISetData')
    eventBus.$off('aFormAttachmentSend')
    eventBus.$off('aFormAttachment')
    eventBus.$off('aFormAttachmentSetData')
    eventBus.$off('aFormAbleToSubmit')
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
      aFormId: (state) => state.AForm.id,
      isOIC: state => state.Auth.User.user_type === 'สป.อว.'
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  methods: {
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.query.id || this.updateId) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    isSameId() {
      return !!this.$route.query.id && this.$route.query.id == this.aFormId;
    },
    stepSetter() {
      if (this.$route.query.step) {
        switch (this.$route.query.step) {
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
            this.currentStep = this.$route.query.step;
        }
      }
    },
    backForm() {
      if (this.currentStep <= 1) return;
      // don't save when back from summary page
      if (this.currentStep <= this.documentSteps.length) {
        this.saveDraft();
      }
      this.currentStep -= 1;
      this.doNotSubmit = false;
      this.$vuetify.goTo("#app");
    },
    async nextForm() {
      if (this.currentStep > this.documentSteps.length) {
        await this.saveDraft(true);
        return this.$route.query.doc_type === "progress"
          ? this.$router.push({ name: "ProgressReportOfferList" })
          : this.$router.push({ name: "MainProjectOffer" });
      }
      let error = await this.saveDraft();
      if (error) return;
      this.currentStep += 1;
      this.$vuetify.goTo("#app");
    },
    async saveDraft(isSubmit = false) {
      // this.requestForm(this.currentStep)
      this.requestForm("all");


      // validate formGeneral
      // if (this.currentStep == 1) {
      //   if (
      //       this.formGeneral.pm_mobile_phone ||
      //       (this.formGeneral.pm_email && !validateEmail(this.formGeneral.pm_email)) ||
      //       this.formGeneral.pc_mobile_phone ||
      //       (this.formGeneral.pc_email && !validateEmail(this.formGeneral.pc_email))
      //   ) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูกต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return true;
      //   }
      // }

      console.log('this.formPlan', this.formPlan)
      let payload = {
        form_ab_general_info: {
          ...this.formGeneral,
          kpi_quantity: this.formOOI.kpi_quantity,
          kpi_quality: this.formOOI.kpi_quality,
          plan_serv_plat_desc: this.formOOI.plan_serv_plat_desc,
          plan_sti_desc: this.formOOI.plan_sti_desc,
          plan_irtc_desc: this.formOOI.plan_irtc_desc,
          plan_collab_desc: this.formOOI.plan_collab_desc,
          status: undefined,
          ops_comment: this.formOOI.ops_comment
        },
        main_project_id: this.$route.query.main_project_id,
        form_ab_project_info: {
          ...this.formProject,
          solution: this.formPlan.solution,
          problem: this.formPlan.problem,
          progress_information: this.formPlan.progress_information,
        },
        project_section_plan: this.formPlan ? this.formPlan : {},
        kpi_annex_plans: this.formOOI.kpi_annex_plans,
        kpi_sub_values: this.formOOI.kpi_sub_values || [],
        attachments: this.formAttachment ? this.formAttachment : [],
        doc_type:
          this.$route.query.doc_type === "progress"
            ? "Progress/Final"
            : undefined,
        form_type: "D",
      };

      //set doc_type from formGeneral to payload.doc_type
      if (this.formGeneral.doc_type) {
        payload.doc_type = this.formGeneral.doc_type;
      }

      console.log("form a payload", payload);

      //check each payload.kpi_annex_plans.attachment has a File or not
      for (let i = 0; i < payload.kpi_annex_plans?.length; i++) {
        if (payload.kpi_annex_plans[i].attachment instanceof File) {
          console.log("annex file detected");
          payload.kpi_annex_plans[i].attachment = await this.uploadFile(
            payload.kpi_annex_plans[i].attachment
          );
        }
      }

      //check each this.formAttachment has a File or not
      if (payload.attachments?.length > 0) {
        let uploadPromises = payload.attachments.map((attachment, index) => {
          if (attachment instanceof File) {
            return this.uploadFile(attachment).then((result) => {
              console.log("file ", index, "is uploaded");
              return result;
            });
          } else {
            return Promise.resolve(attachment);
          }
        });
        payload.attachments = await Promise.all(uploadPromises);
      }

      let res;
      if (this.$route.query.id || this.updateId) {
        // case: update
        payload = {
          id: this.$route.query.id || this.updateId,
          payload: {
            ...payload,
            id: undefined,
          },
        };
        if (this.isFinal) {
          payload.payload.status = isSubmit ? "Submitted" : "Draft";
        } else {
          if (this.userInfo.user_type === "RSP") {
            payload.payload.status = isSubmit ? "Submitted1" : "Draft";

            // check inception status
            if (
              this.masterData.form_a &&
              this.masterData.form_a.status === "Inception"
            ) {
              payload.payload.status = isSubmit ? "Submitted2" : "Inception";
            }
          }
          if (this.userInfo.user_type === "สป.อว.") {
            payload.payload.status = isSubmit ? "Inception" : "Submitted1";
            // check submit2 status
            if (
              this.masterData.form_a &&
              this.masterData.form_a.status === "Submitted2"
            ) {
              payload.payload.status = isSubmit ? "Approved" : "Inception";
            }
          }
        }
        res = await this.$apiFire("BForm/updateFormB", payload);
        if (res && res.id) {
          // success
          this.masterData.form_b = res;
          this.masterData.plan_master = res.plan_master;
          this.updateFormData(this.currentStep);
          this.f1_formKey += 1;
          this.f2_formKey += 1;
          this.f3_formKey += 1;
          this.f4_formKey += 1;
          this.f5_formKey += 1;
          this.f6_formKey += 1;
        } else {
          // error validate
          return true;
        }
      } else {
        // case: store new

        if (this.isFinal) {
          payload.status = isSubmit ? "Submitted" : "Draft";
        } else {
          payload.status = isSubmit ? "Submitted1" : "Draft";
        }
        if (this.$route.query.inception_id) {
          payload.inception_id = this.$route.query.inception_id;
        }
        console.log("payload store: ", payload);
        res = await this.$apiFire("BForm/storeFormB", payload);

        if (res) {
          this.updateId = res;
          this.$store.commit("AForm/setGeneralForm", this.formGeneral);
          window.history.replaceState(
            {},
            null,
            window.location.href + "&id=" + res
          );
        }
      }
      // update changed data
      await this.getMasterData();
    },
    updateFormData(formStep) {
      switch (formStep) {
        case 3:
          eventBus.$emit("aFormPlanSetData");
          eventBus.$emit("aFormPlan");
          break;

        case 4:
          eventBus.$emit("aFormOOISetData");
          eventBus.$emit("aFormOOI");
          break;

        case 5:
          eventBus.$emit("aFormAttachmentSetData");
          eventBus.$emit("aFormAttachment");
          break;
      }
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("aFormGeneral");
          break;

        case 2:
          eventBus.$emit("aFormProject");
          break;

        case 3:
          eventBus.$emit("aFormPlan");
          break;

        case 4:
          eventBus.$emit("aFormOOI");
          break;

        case 5:
          eventBus.$emit("aFormAttachment");
          break;

        default:
          eventBus.$emit("aFormGeneral");
          eventBus.$emit("aFormProject");
          eventBus.$emit("aFormPlan");
          eventBus.$emit("aFormOOI");
          eventBus.$emit("aFormAttachment");
          break;
      }
    },
    retrieveForms() {
      // General form
      eventBus.$on("aFormGeneralSend", (form) => {
        this.formGeneral = form;
        // keep in storage
        this.$store.commit("AForm/setGeneralForm", this.formGeneral);
      });

      // Project form
      eventBus.$on("aFormProjectSend", (form) => {
        this.formProject = form;
        // keep in storage
        this.$store.commit("AForm/setProjectForm", this.formProject);
      });

      // Plan form
      eventBus.$on("aFormPlanSend", (form) => {
        this.formPlan = form;
        console.log("testPlan", this.formPlan);

        // keep in storage
        this.$store.commit("AForm/setPlanForm", this.formPlan);
      });

      // ผลผลิต form
      eventBus.$on("aFormOOISend", (form) => {
        this.formOOI = form;
        console.log("testOOI", this.formOOI);
        
        // keep in storage
        this.$store.commit("AForm/setOOIForm", this.formOOI);
      });

      // Attachment form
      eventBus.$on("aFormAttachmentSend", (form) => {
        this.formAttachment = form;
        // keep in storage
        this.$store.commit("AForm/setAttachmentForm", this.formAttachment);
      });

      // Allow to submit for the summary page
      eventBus.$on("aFormAbleToSubmit", (bool) => {
        this.doNotSubmit = !bool;
      });
    },
    async getMasterData() {
      let res;
      if (
        this.$route.query.inception_id ||
        this.$route.query.id ||
        this.updateId
      ) {
        let id =
          this.$route.query.inception_id ||
          this.$route.query.id ||
          this.updateId;
        // edit (wait for api)
        res = await this.$apiFire("BForm/getEditMasterFormB", id);
        // update component with changing key
        this.f1_formKey += 1;
        this.f2_formKey += 1;
        this.f3_formKey += 1;
        this.f4_formKey += 1;
        this.f5_formKey += 1;
        this.f6_formKey += 1;
      } else {
        // create
        res = await this.$apiFire(
          "BForm/getMasterFormBMain",
          this.$route.query.main_project_id
        );
        this.f1_formKey += 1;
      }
      console.log("masterData", res);
      if (res) {
        this.masterData = res;
        this.plan_code = this.masterData.plan_master[0].plan_code;

        // set data to form for next save
        this.formGeneral = res.form_b?.form_ab_general_info || {}
        this.formProject = res.form_b?.form_ab_project_info || {}
        this.formPlan = res.form_b?.project_section_plan || {}
        this.formPlan.solution = res.form_b?.form_ab_project_info.solution
        this.formPlan.problem = res.form_b?.form_ab_project_info.problem
        this.formPlan.project_section_plan_p1 = res.form_b?.project_section_plan?.project_plan_p1 || []
        // this.formPlan.form_ab_budget = res.form_b?.form_ab_budget
        this.formPlan.progress_information = res.form_b?.form_ab_project_info.progress_information
        this.formOOI.kpi_annex_plans = res.form_b?.kpi_annex_plans
        this.formOOI.kpi_sub_values = res.form_b?.kpi_sub_values || []
        this.formOOI.kpi_quantity = res.form_b?.form_ab_general_info.kpi_quantity
        this.formOOI.kpi_quality = res.form_b?.form_ab_general_info.kpi_quality
        this.formOOI.plan_serv_plat_desc = res.form_b?.form_ab_general_info.plan_serv_plat_desc
        this.formOOI.plan_sti_desc = res.form_b?.form_ab_general_info.plan_sti_desc
        this.formOOI.plan_irtc_desc = res.form_b?.form_ab_general_info.plan_irtc_desc
        this.formOOI.plan_collab_desc = res.form_b?.form_ab_general_info.plan_collab_desc
        this.formOOI.ops_comment = res.form_b?.form_ab_general_info.ops_comment
        this.formAttachment = res.form_b?.attachments || []

      } else {
        this.onCancel();
      }
    },
    onCancel() {
      if (this.isOIC && this.$route.query.preview) {
        this.$router.push({ name: "ProjectOfferFromRSP" });
      } else {
        // back route
        let backRoute = 'AvailablePlan'
        switch (this.userRole) {
          case 'RSP':
            if (this.isFinal) {
              // RSP P/F
              backRoute = 'ProgressReportOfferList'
            } else {
              // RSP S/I
              backRoute = 'MainProjectOffer'
            }
            break

          case 'สป.อว.':
            if (this.isFinal) {
              // OIC P/F
              backRoute = 'ReportFromRSPList'
            } else {
              // OIC S/I
              backRoute = 'ProjectOfferFromRSP'
            }
            break
        }
        this.$router.push({ name: backRoute });
      }
    },
    async uploadFile(file) {
      let formData = new FormData();
      formData.append("files[]", file);
      let payload = {
        files: formData,
      };
      let res = await this.$apiFire("Attachment/uploadFile", formData);
      console.log("res@uploadFile", res);
      if (res.length > 0) {
        console.log("file uploaded", res[0]);
        return res[0];
      }
    },

    summaryForm() {
      this.currentStep = 6;
      this.$vuetify.goTo("#app");
    },
    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

    //change document title
    document.title = 'Form_D_'+this.userInfo.user_type+'_'+this.plan_code+'_'+today;
    let toHide = document.getElementsByClassName('to-hide')
    let pdfPage = document.getElementById('pdf')
    let mainContent = document.getElementById('main')
    let titled = document.getElementsByClassName('titled')
    let toShow = document.getElementsByClassName('to-show')
    let noBoxShadow = document.getElementsByClassName('no-box-shadow')
    let s3p1 = document.getElementsByClassName('s3-p1')
    let s3p1h = document.getElementsByClassName('s3-p1-h')
    let indent_info = document.getElementsByClassName('indent-info')

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.8
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform = "scale(0.75)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "auto";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
    docTypeName() {
      if (this.masterData.form_b?.doc_type === "Progress" && this.masterData.form_b?.progress_month > 0) {
        return (
            "รายงานความก้าวหน้า " +
            this.masterData.form_b?.progress_month.toString() +
            " เดือน"
        );
      } else if (this.masterData.form_b?.doc_type === "Final") {
        return "รายงานฉบับสมบูรณ์";
      }
      return "";
    },
    generateDynamicYearMonths() {
      const fiscalYear = this.masterData.form_b?.fiscal_year ||
                        this.masterData.main_project?.fiscal_year ||
                        new Date().getFullYear() + 543;

      let ym = new Date((fiscalYear - 544).toString() + "-10");
      const yearMonths = [];

      for (let i = 0; i < 12; i++) {
        yearMonths.push(ym.toISOString().substr(0, 7));
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }

      return yearMonths;
    },
     autoField(step, plan_code) {
      switch (step) {
        case 2:
          Object.assign(this.masterData.form_b.form_ab_project_info, {
            principle: "ตัวอย่างหลักการและเหตุผล",
            objective: "ตัวอย่างวัตถุประสงค์",
            industry_group: "ตัวอย่างกลุ่มอุตสาหกรรมเป้าหมาย",
          });
          break;
        case 3: {
            const dynamicMonths = this.generateDynamicYearMonths();
            const totalMonths = 11;

            const project_section_plan_p1_budget = Array.from({ length: totalMonths }, (_, i) => {
              return {
                year_month: dynamicMonths[i],
                month_value: "0.00",
                plan_budget: "0.00",
                plan_budget_rate: "0.00",
                plan_budget_sum: "0.00",
                plan_budget_sum_rate: "0.00",
                use_budget: "0.00",
                use_budget_rate: "0.00",
                use_budget_sum: "0.00",
                use_budget_sum_rate: "0.00",
              };
            });
              const planMonth = Array.from({ length: totalMonths }, (_, i) => {
              return {
                year_month: dynamicMonths[i],
                month_value: "0.00",
              };
            });
            project_section_plan_p1_budget.push({
              year_month: dynamicMonths[11],
              month_value: "0.00",
              plan_budget: "100.00",
              plan_budget_rate: "100.00",
              plan_budget_sum: "100.00",
              plan_budget_sum_rate: "0.00",
              use_budget: "0.00",
              use_budget_rate: "0.00",
              use_budget_sum: "0.00",
              use_budget_sum_rate: "0.00",
            })
            planMonth.push({
              year_month: dynamicMonths[11],
              month_value: "100.00",
           
            })
            const project_plan_p1 = [
              {
                id: null,
                p1_activity_name: "ทดสอบกิจกรรมที่ 1",
                p1_wf: "1.00",
                project_section_plan_month: planMonth,
                percent: "100.00"
              }
            ];
            // ensure form_b exists
            this.masterData.form_b.project_section_plan = {
              project_section_plan_p1_budget,
              project_section_budget: [],
               project_plan_p3: [],
               project_plan_p1,
               project_section_budget_df:  [
                      {
                        budget_name: "รายการทดสอบ",
                        budget_cost: "100",
                        budget_amount: "100",
                        budget_unit: "100",
                        budgets: "100",
                        budget_detail: "รายละเอียดทดสอบ",
                      },
                    ],

            };
             Object.assign(this.masterData.form_b.form_ab_project_info, {
                progress_information: "<p>ทดสอบ</p>",
          });
            break;
          }
        case 4:
          // กำหนดค่า kpi_quantity และ kpi_quality
          if (this.masterData.kpi_masters) {
            this.masterData.kpi_masters.forEach((kpiMaster) => {
              kpiMaster.kpi_sub_masters.forEach((subMaster) => {
                if (!subMaster.kpi_sub_values) {
                  subMaster.kpi_sub_values = {
                    kpi_sub_master_id: subMaster.id,
                    kpi_sub_value: Math.floor(Math.random() * 100) + 1,
                    description: "คำอธิบายทดสอบ",
                  };
                }
              });
            });
          }
          break;
      }

      this.updateSubFormComponent();
      this.$forceUpdate();
    },
    updateSubFormComponent() {
      this.f1_formKey += 1;
      this.f2_formKey += 1;
      this.f3_formKey += 1;
      this.f4_formKey += 1;
      this.f5_formKey += 1;
      this.f6_formKey += 1;
    },
  },
};
</script>

<style scoped lang="scss">
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
